const themeConfig = {
  name: "default",
  palette: {
    background: {
      default: "#F6F1EC",
    },
    primary: {
      main: "#E44425",
    },
    secondary: {
      main: "#F2B705",
    },
    text: {
      primary: "#121212",
    },
  },
  typography: {
    body1: {
      fontFamily: "inter, Arial",
      fontSize: 15,
      "@media (min-width:600px)": {
        fontSize: 17,
      },
    },
    h1: {
      fontWeight: "700",
      fontSize: 32,
    },
    h2: {
      fontWeight: "700",
      fontSize: 24,
    },
    h3: {
      fontWeight: "500",
      fontSize: 21,
    },
    h4: {
      fontWeight: "500",
      fontSize: 19,
    },
    h5: {
      fontWeight: "500",
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "10px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          fontWeight: "600",
          fontSize: 19,
          textTransform: "none",
          variants: [],
        },
      },
    },
  },
};

declare module "@mui/material" {
  interface ThemeOptions {
    name: string;
    embedded?: boolean;
  }
}

declare module "@mui/material/styles" {
  interface Theme {
    name: string;
    embedded?: boolean;
  }
}

export default themeConfig;
